import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { authHeaders, http } from './http.js';
import { isActiveStatus } from '../utils/constants.js';

async function listExecutions(getToken, companyId, processId) {
    const headers = await authHeaders(getToken);
    const { data } = await http.get(`/company/${companyId}/process/${processId}/execution`, { headers });
    return data;
}

async function getLastExecution(getToken, companyId, processId) {
    const headers = await authHeaders(getToken);
    const { data } = await http.get(`/company/${companyId}/process/${processId}/execution/last`, { headers });
    return data;
}

async function runProcess(getToken, companyId, processId) {
    const headers = await authHeaders(getToken);
    const { data } = await http.post(`/company/${companyId}/process/${processId}/task`, null, { headers });
    return data;
}

export function useExecutions(companyId, processId) {
    const { getToken } = useAuth();
    return useQuery({
        queryKey: ['executions', companyId, processId],
        queryFn: () => listExecutions(getToken, companyId, processId),
        enabled: Boolean(companyId && processId),
        refetchInterval: (query) => {
            const list = query.state.data;
            return list?.some((e) => isActiveStatus(e.status)) ? 3000 : false;
        },
    });
}

export function useLastExecution(companyId, processId) {
    const { getToken } = useAuth();
    return useQuery({
        queryKey: ['lastExecution', companyId, processId],
        queryFn: () => getLastExecution(getToken, companyId, processId),
        enabled: Boolean(companyId && processId),
        refetchInterval: (query) => (isActiveStatus(query.state.data?.status) ? 3000 : false),
    });
}

export function useRunProcess(companyId, processId) {
    const { getToken } = useAuth();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => runProcess(getToken, companyId, processId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['executions', companyId, processId] });
            queryClient.invalidateQueries({ queryKey: ['lastExecution', companyId, processId] });
        },
    });
}